/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-confusing-arrow */
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import FoodkidItem from './Item';
import _schoolSelector from '@app/redux/school/school.selector';
import _othersSelector from '@app/redux/others/selector';
import _fkMenuApis from '@app/apis/foodkid/menu.api';
import { STATUS_PROCESS } from '@app/constants/index';
import { useFkLamTronSo } from '@app/hooks/useSchoolSetting';
import { dispatchReport } from './reportHandlers';

const FookidList = ({
    dateTo,
    dateFrom,
    countClickExport,
    kidGroupIds,
    listReport,
    onChangeListReport,
    onExportDone,
}) => {
    const menulist = useRef([]);
    const menuSchoolFoods = useRef([]);
    const menuServices = useRef([]);
    const menudishs = useRef([]);
    const proFoods = useRef([]);
    const schoolFoods = useRef([]);

    // ── Selectors ──
    const ageGroup = useSelector(_othersSelector.ageGroup);
    const allKidGroup = useSelector(_othersSelector.kidGroup);
    const units = useSelector(_othersSelector.units);
    const schoolInfo = useSelector(_othersSelector.schoolInfo);
    const locationInfo = useSelector(_othersSelector.locationInfo);
    const organizationInfo = useSelector(_othersSelector.organizationInfo);
    const mealService = useSelector(_othersSelector.mealService);
    const supplier = useSelector(_othersSelector.supplier);
    const dish = useSelector(_othersSelector.dish);
    const inventories = useSelector(_othersSelector.inventories);
    const packaging = useSelector(_othersSelector.packaging);
    const invoiceForm = useSelector(_othersSelector.invoiceForm);
    const oId = useSelector(_schoolSelector.currentSchool);
    const { decimal: decimalRound } = useFkLamTronSo();

    // ── Memoized values ──
    const kidGroupIdSet = useMemo(() => new Set(kidGroupIds), [kidGroupIds]);

    const kidGroup = useMemo(
        () => allKidGroup?.filter((o) => kidGroupIdSet.has(o.kg_id)),
        [allKidGroup, kidGroupIdSet],
    );

    // ── Status helpers ──
    const onSetStatus = useCallback(
        (listItem, statusValue) => {
            const ids = new Set(listItem.map((o) => o.id));
            onChangeListReport((data) =>
                data.map((o) => {
                    if (!ids.has(o.id)) return o;
                    return {
                        ...o,
                        status: statusValue,
                        ...(statusValue === STATUS_PROCESS.DONE && {
                            isCheck: false,
                        }),
                    };
                }),
            );
        },
        [onChangeListReport],
    );

    const isExportingRef = useRef(false);

    // ── Fetch data & export ──
    const getData = async (_oId, _dateFrom, _dateTo) => {
        if (isExportingRef.current) return; // đang xuất rồi, bỏ qua
        isExportingRef.current = true;

        try {
            const listCheck = listReport.filter(
                (o) => o.isCheck && o.category === 1,
            );
            if (listCheck.length === 0) return;

            onSetStatus(listCheck, STATUS_PROCESS.AWAITING);

            // Fetch menu data
            const { status, data } = await _fkMenuApis.getMenuByDateAndKidGroup({
                ids: kidGroupIds,
                dateFrom: _dateFrom,
                dateTo: _dateTo,
                o_id: _oId,
                typeGetData: 1,
            });

            if (status === 200) {
                const d = data.data;
                menulist.current = d.list;
                menuSchoolFoods.current = d.menuSchoolFoods;
                menuServices.current = d.menuServices;
                menudishs.current = d.menuDishs;
                proFoods.current = d.proFoods;
                schoolFoods.current = d.schoolFoods;
            } else {
                menulist.current = [];
                menuSchoolFoods.current = [];
                menuServices.current = [];
                menudishs.current = [];
                proFoods.current = [];
                schoolFoods.current = [];
            }

            // Context object chung cho tất cả handlers
            const ctx = {
                refs: {
                    menulist: menulist.current,
                    menuSchoolFoods: menuSchoolFoods.current,
                    menuServices: menuServices.current,
                    menudishs: menudishs.current,
                    proFoods: proFoods.current,
                    schoolFoods: schoolFoods.current,
                },
                oId: _oId,
                dateFrom: _dateFrom,
                dateTo: _dateTo,
                kidGroupIds,
                kidGroupIdSet,
                kidGroup,
                units,
                ageGroup,
                schoolInfo,
                locationInfo,
                organizationInfo,
                mealService,
                supplier,
                dish,
                inventories,
                packaging,
                invoiceForm,
                decimalRound,
                STATUS_PROCESS,
            };

            // Process từng report sequentially
            for (const elem of listCheck) {
                onSetStatus([elem], STATUS_PROCESS.PROCESSING);
                const isDone = await dispatchReport(
                    elem.code,
                    ctx,
                );
                if (isDone) {
                    onSetStatus([elem], STATUS_PROCESS.DONE);
                }
            }
        } finally {
            isExportingRef.current = false;
            onExportDone?.();
        }
    };

    useEffect(() => {
        if (countClickExport && oId) {
            getData(oId, dateFrom, dateTo);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countClickExport]);

    // ── UI ──
    const onCheck = useCallback(
        (s, item) => {
            const checkValue = s.target.checked;
            onChangeListReport((prev) =>
                prev.map((o) =>
                    o.id === item.id ? { ...o, isCheck: checkValue } : o,
                ),
            );
        },
        [onChangeListReport],
    );

    const filteredList = useMemo(
        () => listReport.filter((o) => o.category === 1),
        [listReport],
    );

    return (
        <>
            {filteredList.map((item) => (
                <FoodkidItem
                    key={item.id}
                    item={item}
                    onCheck={(s) => onCheck(s, item)}
                />
            ))}
        </>
    );
};

export default FookidList;
